var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconDownloadInkPerJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 2.78125C16.8438 2.40625 16.2812 2.40625 15.9062 2.78125L10 8.6875L4.09375 2.78125C3.71875 2.40625 3.15625 2.40625 2.78125 2.78125C2.40625 3.15625 2.40625 3.71875 2.78125 4.09375L8.6875 10L2.78125 15.9062C2.40625 16.2812 2.40625 16.8438 2.78125 17.2188C2.96875 17.4063 3.15625 17.5 3.4375 17.5C3.71875 17.5 3.90625 17.4063 4.09375 17.2188L10 11.3125L15.9062 17.2188C16.0937 17.4063 16.375 17.5 16.5625 17.5C16.75 17.5 17.0313 17.4063 17.2188 17.2188C17.5938 16.8438 17.5938 16.2812 17.2188 15.9062L11.3125 10L17.2188 4.09375C17.5938 3.71875 17.5938 3.15625 17.2188 2.78125Z",
    fill: "#354052"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconDownloadInkPerJob);
export default __webpack_public_path__ + "static/media/CloseIconDownloadInkPerJob.5e0f54da.svg";
export { ForwardRef as ReactComponent };